import * as React from "react";
import {
  Box,
  Card,
  Typography,
  Divider,
  LinearProgress,
  useTheme,
  IconButton,
  Stack, Tabs, Tab,
  InputBase,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Link,
  useMediaQuery, Collapse, CircularProgress, ButtonBase
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchData } from "assets/utils";
import SeriesIcon from "components/SeriesIcon";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from '@mui/icons-material/Person';
import { shortenUsername } from "assets/utils";
import { useSimulationData } from "assets/utils";
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import { WinIcon } from "assets/Icons";
import { LoseIcon } from "assets/Icons";
import { useHead2Head } from "assets/utils";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddIcon from '@mui/icons-material/Add';
import { useSearch } from "assets/utils";
import { getBoxShadow } from "components/ShadowBox";
import ShadowBox from 'components/ShadowBox';
import OutlinedBox from 'components/OutlinedBox';
import { getLastName, getFirstInitialAndLastName, formatDateDifference } from "assets/utils";

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import { useTranslation, Trans } from "react-i18next";
import i18n from "i18n";

export function ActivityTab({ labels, value, setValue }) {
  return <Tabs
      centered
      value={value}
      textColor="inherit"
      indicatorColor="inherit"
      onChange={(event, newValue) => setValue(newValue)}
      aria-label="basic tabs example"
      sx={{
        borderRadius: 2,
        backgroundColor: "primary.main",
        mt: 2,
        mb: 1,
        boxShadow: getBoxShadow(),
        "& .MuiTab-root": {
          color: "rgba(255,255,255,0.7)",
        },
        "& .Mui-selected": {
          color: "#fff",
        },
        "& .MuiTabs-indicator": {
          height: 3,
          backgroundColor: "#fff",
        },
      }}
    >
      {labels.map((label, index) => (
        <Tab key={index} label={label} />
      ))}
    </Tabs>
}

export default function ActivityCard({ activity, name, name_club, rank }) {
  const { t } = useTranslation();
  const padel_activity = activity?.padel ?? [];

  const [value, setValue] = React.useState(0);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogData, setDialogData] = React.useState(null);

  React.useEffect(() => {
    if (padel_activity.length > 0) {
      setValue(0);
    } else {
      setValue(0); // default to singles tab if no activity, but could be anything since both are empty
    }
  }, [padel_activity]);



  return (
    <>

    <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", mt: 6, mb: 2}}>
      <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" id="matches">
      {t("activityCard.upcomingMatches")}
      </Typography>
      <IconButton aria-label="Example" color="primary" onClick={() => setDialogOpen(true)}>
        <InfoIcon color="primary" />
      </IconButton>
    </Box>
    <ActivityCardDialog open={dialogOpen} setOpen={setDialogOpen} />

    <ActivityTab labels={[t("activityCard.tabTournaments", {count: padel_activity.length}), t("activityCard.tabSimulation")]} value={value} setValue={setValue} />

    {value === 0 && padel_activity.length > 0 && <Stack sx={{ gap: 1}}>

      {
        padel_activity.map((item, index) => (
          <React.Fragment key={`${item.sid}-${index}`}>
            <ActivityLine data={item} doubles={true} setDialogData={setDialogData} />
          </React.Fragment>
        ))
      }
    </Stack>}

    {value === 1 && <SimulationFetch setDialogData={setDialogData} name={name} name_club={name_club} rank={rank} />}

    <OutlinedBox sx={{py: 1, px: 1, fontStyle: "italic", textAlign: "center", display: (value === 0 && padel_activity.length > 0) || (value === 1) ? "none" : "block"}}>
      <Typography variant="body2" color="text.secondary">
      {t("activityCard.noPlanned")}
      </Typography>
    </OutlinedBox>

    <H2HDialog open={dialogData != null} onClose={() => setDialogData(null)} dialogData={dialogData}/>

    </>
  );
}

function SimulationFetch({ setDialogData, name, name_club, rank }) {
    const { t } = useTranslation();
    const playerId = parseInt(useParams()["*"]);
    const [search, setSearch] = React.useState("");
    const [favoritesSimulation, favoritesFetching] = useSimulationData(playerId, "");
    const [searchSimulation, searchFetching] = useSimulationData(playerId, search);

    const simulation = search.length >= 5 ? searchSimulation : favoritesSimulation;
    const fetching = search.length >= 5 ? searchFetching : favoritesFetching;

    const theme = useTheme();

    const visibleCount = 10;


    return <Stack sx={{ gap: 1}}>

      <OutlinedBox sx={{py: 0.5, px: 1, display: "flex", alignItems: "center", gap: 1}}>
          <InputBase 
            value={search} 
            inputProps={{style: {textTransform: search.length > 0 ? "capitalize" : "none"}}}
            autoComplete='off' 
            sx={{width: "100%"}}
            onChange={(e) => setSearch(e.target.value)} 
            startAdornment={<SearchIcon style={{color: theme.palette.text.secondary, marginRight: 8}} />} 
            placeholder={t("activityCard.searchPlayer")}/>
      </OutlinedBox>

    {(search.length ===0 || search.length >= 5) && simulation
      ? simulation
          .filter(item => item.o_id != playerId)
          .sort((a, b) => a.o_score - b.o_score)
          .slice(0, visibleCount)
          .map((item, index) => (
            <React.Fragment key={`${playerId}-${item.sid}-${index}`}>
              <ActivityLine data={item} doubles={false} name={name} name_club={name_club} rank={rank} setDialogData={setDialogData} />
            </React.Fragment>
          ))
      : null}

      {search.length  < 5 ?
      <OutlinedBox sx={{py: 1, px: 1, fontStyle: "italic", textAlign: "center"}}>
        <Typography variant="body2" color="text.secondary">
          {search.length === 0 ? t("activityCard.addFavorites") : t("activityCard.refineSearchSimulations")}
        </Typography>
      </OutlinedBox>
      : null}

      {search.length >= 5 && !fetching && simulation.length === 0 ?
      <OutlinedBox sx={{py: 1, px: 1, fontStyle: "italic", textAlign: "center"}}>
        <Typography variant="body2" color="text.secondary">
          {t("activityCard.noPlayersFound")}
        </Typography>
      </OutlinedBox>
      : null}


      </Stack>
}


function formatDate(dateInput) {
  const date = new Date(dateInput);

  if (Number.isNaN(date.getTime())) return "";

  const parts = new Intl.DateTimeFormat(i18n.t("dates.locale"), {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);

  const get = (type) =>
    parts.find((part) => part.type === type)?.value.replace(".", "") ?? "";

  const weekday = get("weekday");

  return `${weekday} ${get("day")} ${get("month")} • ${get("hour")}u${get("minute")}`;
}

export function PlayerName({
  id,
  name,
  name_club,
  rank,
  rankColor,
  ageclass,
  right,
  sx,
  color,
  shortenUsernameLength = 20,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navigateToUser = () => {
        fetchData(id, (content) => {
            navigate("/speler/" + id, {
                state: { ...content, ts: new Date().getTime() },
            });
        });
    };

  return (
    <Box
      onClick={() => id && navigateToUser()}
      sx={{
        width: "100%",
        minWidth: 0,
        overflow: "hidden",
        textAlign: right ? "right" : "left",
        cursor: id ? "pointer" : "default",
        ...sx,
      }}
    >
      <Typography
  variant="caption"
  component="div"
  sx={{
    display: "flex",
    alignItems: "baseline",
    justifyContent: right ? "flex-end" : "flex-start",
    width: "100%",
    minWidth: 0,
    color: "text.primary",
  }}
>
        <Box
          component="span"
          title={name}
          sx={{
            flex: "0 1 auto",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontWeight: 700,
            textAlign: right ? "right" : "left",
            fontSize: 12,
          }}
        >
          {shortenUsername(name, shortenUsernameLength) || t("common.unknown")}
        </Box>

        {rank ? (
          <Box
            component="b"
            sx={{
              flexShrink: 0,
              ml: "5px",
              color: rankColor || "#777",
              fontSize: 12,
            }}
          >
            P{rank}
          </Box>
        ) : null}
      </Typography>

      {name_club ? (
        <Typography
          variant="caption"
          component="div"
          noWrap
          title={name_club}
          sx={{
            width: "100%",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: "normal",
            fontSize: 10,
            color: "text.secondary",
          }}
        >
          {name_club}
        </Typography>
      ) : null}
    </Box>
  );
}

export function AccentBar({ color, width=6, borderLeft='2px', borderRight='2px' }) {
  return (
    <Box
      sx={{
        width: width,
        backgroundColor: color,
        flexShrink: 0,
        borderBottomLeftRadius: borderLeft,
        borderBottomRightRadius: borderRight,
        borderTopLeftRadius: borderLeft,
        borderTopRightRadius: borderRight,
      }}
    />
  );
}

function VSSign() {
  const { t } = useTranslation();
  return <Box
      aria-label="versus"
      sx={{
        width: 20,
        height: 20,
        minWidth: 20,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "50%",
        bgcolor: "background.paper",
        color: "text.primary",
        fontSize: 8,
        fontWeight: 700,
        lineHeight: 1,
        userSelect: "none",
      }}

    >

      {t("common.versus")}

    </Box>;
}

export function ActivityLine({ data, doubles, setDialogData, firstPlayerClickable = false, name, name_club, rank }) {
  const { t } = useTranslation();
  const theme = useTheme();

  const nameStr = name ?? data?.my_name;
  const name_clubStr = name_club ?? data?.my_name_club;
  const rankStr = rank ?? data?.my_pts;

  const playerId = parseInt(useParams()["*"]) || data?.my_id;

  const winPct = Math.round((data.o_score ?? 0.5) * 100);

  const opacity = data.o1_id || data.o_id ? 1 : 0.5;

  const t1Color = theme.palette.primary.main;
  const t2Color = "#E8CBFE";
  const t2ColorText = theme.palette.primary.light;

  const shortenUsernameLength = useMediaQuery(theme.breakpoints.down("sm")) ? 16 : 20;

  const [open, setOpen] = React.useState(false);

  return (
    <ShadowBox
      sx={{
        pt: 1.5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        /*"&:hover": {
          backgroundColor: "action.hover",
        },*/
      }}
    >

        {/*<Avatar
            {...stringAvatarProps(data.o_id, data.o_name)}
        />*/}

        <Stack sx={{justifyContent: "space-between", alignItems:"center", flexDirection: "row", width: "100%", px: 1, pb: 1, minWidth: 0,}}>
            <Box sx={{ display: "flex", alignItems: "stretch", gap: 1, width:"50%", flex: "0 0 calc(50% - 10px)", width: "calc(50% - 10px)", maxWidth: "calc(50% - 10px)", minWidth: 0, overflow: "hidden", paddingRight: 0.5 }}>
              {/*<AccentBar color={t1Color} width="5px" borderLeft="0px" />*/}

              <Stack sx={{ alignItems: "flex-start", flexDirection: "column", flex: 1, minWidth: 0, overflow: "hidden" }}>
                <PlayerName id={firstPlayerClickable ? data.my_id : null} name={nameStr} name_club={name_clubStr} rank={rankStr} color={t1Color} shortenUsernameLength={shortenUsernameLength} />
                {doubles ? <PlayerName id={data.p_id} name={data.p_name} rank={data.p_pts} shortenUsernameLength={shortenUsernameLength} /> : null}
              </Stack>
            </Box>

            <VSSign />

            <Box sx={{ display: "flex", alignItems: "stretch", gap: 1, width:"calc(50% - 10px)", flex: "0 0 calc(50% - 10px)", width: "calc(50% - 10px)", maxWidth: "calc(50% - 10px)", minWidth: 0, overflow: "hidden", paddingLeft: 0.5 }}>
                <Stack sx={{ alignItems: "flex-end", flexDirection: "column", flex: 1, minWidth: 0, overflow: "hidden", }}>
                  <PlayerName id={doubles ? data.o1_id : data.o_id} name={doubles ? data.o1_name : data.o_name} rank={doubles ? data.o1_pts : data.o_pts} right name_club={data.o_name_club} color={t2ColorText} shortenUsernameLength={shortenUsernameLength} />
                  {doubles && data.o1_id > 0 ? <PlayerName id={data.o2_id} name={data.o2_name} rank={data.o2_pts} right shortenUsernameLength={shortenUsernameLength} /> : null}
                </Stack>
                {/*<AccentBar color={t2Color} width="5px" borderRight="0px" />*/}
            </Box>
        </Stack>

        <Box sx={{px: 1, width: "100%", alignItems: "center", display: "flex", flexDirection: "column", mt: 1, mb: 1}}>

        <Stack sx={{justifyContent: "space-between", flexDirection: "row", width: "100%", alignItems: "flex-end", mb: 0.5, opacity: opacity}}>
            <Typography variant="h5" sx={{fontWeight: 700, color: t1Color, width: 60, fontSize: 20, lineHeight: "1em"}}>
                {winPct}%
            </Typography>

            <Typography variant="caption" color="#999" sx={{lineHeight: "1em", fontWeight: "normal"}}>
                {t("activityCard.winPrediction")}
            </Typography>

            <Typography variant="h5" sx={{fontWeight: 700, color: "#aaa", width: 60, fontSize: 20, lineHeight: "1em", textAlign: "right"}}>
                {100 - winPct}%
            </Typography>
        </Stack>

        <LinearProgress variant="determinate" value={winPct} 
            sx={{width: "100%", borderRadius: 5, height: 10,
                    backgroundColor: "#ddd",
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: t1Color
                    }, opacity: opacity
            }} 
            
            />

        </Box>


        <Divider sx={{width: "100%", mt: 0.5}} />
        
        <Stack
          sx={{
            justifyContent: "space-between",
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            px: 1,
            pt: 0.5,
            pb: 0.5,
            gap: 1,
            "&:hover": {
                cursor: "pointer",
            },
          }}

          onClick={() => setOpen((prev) => !prev)}
        >
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.primary.main,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              lineHeight: "1.4em",
              flexShrink: 1,
              minWidth: 0,
              fontSize: 12,
              "&:hover": {
                color: theme.palette.primary.dark,
                cursor: data.url ? "pointer" : "default",
              },
            }}
            onClick={() => {
              if (data.url) {
                window.open(data.url, "_blank");
              }
            }}
          >
            {data.circuit ? `P${data.circuit} ${data.rn?.replace("finale kwalificatie", "Q").replace("finale", "F").replace("poule", "Poule").replace(" ", "")} • ` : ""} {data.title} 
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", ml: "auto", flexShrink: 0 }}>
            <Typography
              variant="caption"
              sx={{
                color: "#a0a0a0",
                whiteSpace: "nowrap",
                lineHeight: "1.4em",
                fontSize: 12,
                marginLeft: '10px',
              }}
            >
              {data.planned ? `${formatDate(data.planned)}` : ""}
            </Typography>

            {open ? (
              <KeyboardArrowUpIcon sx={{ ml: 0.25, color: "#ccc" }} />
            ) : (
              <KeyboardArrowDownIcon sx={{ ml: 0.25, color: "#ccc" }} />
            )}
          </Box>
        </Stack>

        {open && <ActivityLineDetail isSingles={!doubles} myId={data.my_id} opponentId={doubles ? data.o1_id : data.o_id} partnerId={doubles ? data.p_id : null} opponentPartnerId={doubles && data.o1_id > 0 ? data.o2_id : null} setDialogData={setDialogData} />}

    </ShadowBox>

    
  );
}


function ActivityLineDetail({isSingles, myId, opponentId, partnerId, opponentPartnerId, setDialogData}) {
  const data = useHead2Head(myId, opponentId, partnerId, opponentPartnerId);

  const { t } = useTranslation();

    return <Box sx={{width: "100%", mt: 1, pt: 2}}>
      <Collapse in={!data} timeout="auto" unmountOnExit>
        <CircularProgress size={24} sx={{display: "block", mx: "auto", my: 2}} />
      </Collapse>

      <Collapse in={!!data} timeout="auto" unmountOnExit>

        <H2HFullSummary data={data} isSingles={isSingles} />

        <Box sx={{px: 1, pb: 1}}>
        <ButtonBase
                centerRipple={true}
                onClick={() => setDialogData({player1: myId, player2: opponentId, player3: partnerId, player4: opponentPartnerId})}
                sx={{ 
                  display: "flex", justifyContent: "center", borderRadius: 2, backgroundColor: (theme) => theme.palette.primary.main,
                  borderRadius: 2,
                  px: 1.5,
                  py: 1,
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  width: "100%",
                }}
              >
                <LeaderboardIcon sx={{ fontSize: 18, color: 'white' }} />
                <Typography sx={{ fontSize: 12, color: 'white', fontWeight: 600}}>
                  {t("activityCard.viewFullSimulation")}
                </Typography>
              </ButtonBase>
          </Box>

      </Collapse>

    </Box>
}

function ActivityCardDialog({open, setOpen}) {
  const { t } = useTranslation();
  const handleClose = () => {
    setOpen(false);
  };

  

  return <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{t("activityCard.dialogTitle")}</DialogTitle>
            <DialogContent>
            <DialogContentText>
              <Trans i18nKey="activityCard.dialogBody" components={{ br: <br/> }} />
            </DialogContentText>
            
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>{t("common.close")}</Button>
            </DialogActions>
        </Dialog>
}

// H2H

function H2HRecentResults({summary}) {
  const { t } = useTranslation();
  return <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", p: 1}}>
    <Typography variant="caption" color="text.primary_bold" fontWeight="normal">
      {shortenUsername(summary?.name)}
    </Typography>

    <Box sx={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
      {summary && summary.activity && summary.activity.padel.slice(0,5).map((item, index) => (
          item === 1 ? <WinIcon key={index} /> : item === 0 ? <LoseIcon key={index} /> : null
      ))}

      {summary && summary.activity.padel.length === 0 && <Typography variant="caption" color="text.secondary" sx={{mr: '5px'}}>
        {t("common.none")}
      </Typography>}
    </Box>
  </Box>
}

function H2HData({value1, value2, value3, title, suffix, prefix}) {
  return <Stack key={value1} sx={{justifyContent: "space-between", width: "100%", flexDirection: "row", alignItems: "center", px: 1, py: 0.5}}>
    <Typography variant="caption" color="text.primary_bold" sx={{fontWeight: title ? "bold" : "normal", width: "40%"}}>
      {value1}
    </Typography>
    <Typography variant="caption" color={value2 > value3 && !title ? "primary.main" : "text.primary_bold"} sx={{width: "30%", fontWeight: "bold", pl: 1, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}>
      {value2 != null ? prefix : ""}{value2}{value2 != null ? suffix : ""}
    </Typography>
    <Typography variant="caption" color={value2 > value3 || title ? "text.primary_bold" : "primary.main"} sx={{width: "30%", fontWeight: "bold", pl: 1, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}>
      {value3 != null ? prefix : ""}{value3}{value3 != null ? suffix : ""}
    </Typography>
  </Stack>
}

function H2HSummary({my_summary, o_summary}) {

  const { t } = useTranslation();

  const my_win_pct = my_summary?.activity?.padel?.length > 0 ? Math.round((my_summary.activity.padel.filter(r => r === 1).length / my_summary.activity.padel.length) * 100) : 0;
  const o_win_pct = o_summary?.activity?.padel?.length > 0 ? Math.round((o_summary.activity.padel.filter(r => r === 1).length / o_summary.activity.padel.length) * 100) : 0;

  const recent_win_pct = my_summary?.nm_60d > 0 ? Math.round((my_summary.nw_60d / my_summary.nm_60d) * 100) : 0;
  const o_recent_win_pct = o_summary?.nm_60d > 0 ? Math.round((o_summary.nw_60d/ o_summary.nm_60d) * 100) : 0;

  return <OutlinedBox sx={{m: 1, mt: 0}}>
          <H2HData value1={t("h2h.lastYear")} value2={shortenUsername(my_summary?.name, 5)} value3={shortenUsername(o_summary?.name, 5)} title />
          <Divider sx={{width: "100%"}}/>
          <H2HData value1={t("h2h.matches")} value2={my_summary?.activity?.padel?.length ?? null} value3={o_summary?.activity?.padel?.length ?? null} />
          <H2HData value1={t("h2h.winRatio")} value2={my_win_pct} value3={o_win_pct} suffix="%" />
          <H2HData value1={t("h2h.matches60d")} value2={my_summary?.nm_60d ?? null} value3={o_summary?.nm_60d ?? null} />
          <H2HData value1={t("h2h.winRatio60d")} value2={recent_win_pct} value3={o_recent_win_pct} suffix="%" />
          <H2HData value1={t("h2h.ranking")} value2={my_summary?.padel_pts ?? null} value3={o_summary?.padel_pts ?? null} prefix="P" />
          <H2HData value1={t("h2h.playStrength")} value2={my_summary ? (Math.round(my_summary.padel_elo_pts / 10) * 10) : null} value3={o_summary ? (Math.round(o_summary?.padel_elo_pts / 10) * 10) : null} prefix="P" />
        </OutlinedBox>
}

export function H2HHeader({data, myId, myName, myPts, myClub, partnerId, opponentId, opponentName, opponentPts, opponentClub, opponentPartnerId, showPlayers=true}) {
  const theme = useTheme();
  const { t } = useTranslation();

  const t1Color = theme.palette.primary.main;
  const t2Color = "#E8CBFE";
  const t2ColorText = theme.palette.primary.light;

  const winPct = Math.round((data?.padel_score ?? 0.5) * 100);

  const shortenUsernameLength = useMediaQuery(theme.breakpoints.down("sm")) ? 16 : 20;

  return <>{showPlayers && <Stack sx={{justifyContent: "space-between", alignItems: "center", flexDirection: "row", px: 1, pb: 1, mt: 2, minWidth: 0,}}>
            <Box sx={{ display: "flex", alignItems: "stretch", gap: 1, flex: "1 1 0", maxWidth: "calc(50% - 10px)", minWidth: 0, overflow: "hidden", paddingRight: 0.5, }}>
              {/*<AccentBar color={t1Color} />*/}

              <Stack sx={{ alignItems: "flex-start", flexDirection: "column", flex: 1, minWidth: 0, overflow: "hidden" }}>
                <PlayerName id={myId} name={myName ?? data?.my_summary?.name} rank={myPts ?? data?.my_summary?.padel_pts} name_club={data?.p_summary ? null : myClub ?? data?.my_summary?.club} color={t1Color} shortenUsernameLength={shortenUsernameLength} />
                {data?.p_summary ? <PlayerName id={partnerId} name={data.p_summary.name} rank={data.p_summary.padel_pts} color={t1Color} shortenUsernameLength={shortenUsernameLength} /> : null}
              </Stack>
            </Box>

            <VSSign />

            <Box sx={{ display: "flex", alignItems: "stretch", gap: 1, flex: "1 1 0", maxWidth: "calc(50% - 10px)", minWidth: 0, overflow: "hidden", paddingLeft: 0.5, }}>
                <Stack sx={{ alignItems: "flex-end", flexDirection: "column", flex: 1, minWidth: 0, overflow: "hidden", }}>
                  <PlayerName id={opponentId} name={opponentName ?? data?.o_summary?.name} rank={opponentPts ?? data?.o_summary?.padel_pts} name_club={data?.op_summary ? null : opponentClub ?? data?.o_summary?.club} right color={t2ColorText} shortenUsernameLength={shortenUsernameLength} />
                  {data?.op_summary ? <PlayerName id={opponentPartnerId} name={data.op_summary.name} rank={data.op_summary.padel_pts} color={t2ColorText} right shortenUsernameLength={shortenUsernameLength} /> : null}
                </Stack>
                {/*<AccentBar color={t2Color} />*/}
            </Box>
        </Stack>}

        <Box sx={{px: 1, width: "100%", alignItems: "center", display: "flex", flexDirection: "column", pt: 1}}>

        <Stack sx={{justifyContent: "space-between", flexDirection: "row", width: "100%", alignItems: "flex-end", mb: 0.5}}>
            <Typography variant="h5" sx={{fontWeight: 700, color: t1Color, width: 60, lineHeight: "1em"}}>
                {winPct}%
            </Typography>

            <Typography variant="caption" color="#999" sx={{lineHeight: "1em", fontWeight: "normal"}}>
                {t("activityCard.winPrediction")}
            </Typography>

            <Typography variant="h5" sx={{fontWeight: 700, color: "#aaa", width: 60, lineHeight: "1em", textAlign: "right"}}>
                {100 - winPct}%
            </Typography>
        </Stack>

        <LinearProgress variant="determinate" value={winPct} 
            sx={{width: "100%", borderRadius: 5, height: 10,
                    backgroundColor: "#ddd",
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: t1Color
                    }
            }} 
            
            />

        </Box></>
}

export function H2HSelect({data, setSearchDialogMode}) {
  const { t } = useTranslation();
  return <Stack sx={{flexDirection: "row", gap: 0.5, px: 1, flexWrap: "wrap"}}>
            <Button variant="outlined" onClick={() => setSearchDialogMode(1)} sx={{width: "calc(50% - 4px)", fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}} >
              {data ? t("h2h.changePlayer", {name: shortenUsername(data?.my_summary?.name, 5)}) : t("h2h.searchPlayer")}
            </Button>
            <Button variant="outlined" onClick={() => setSearchDialogMode(2)} sx={{width: "calc(50% - 4px)", fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}} >
              {data ? t("h2h.changePlayer", {name: shortenUsername(data?.o_summary?.name, 5)}) : t("h2h.searchOpponent")}
            </Button>
            <Button variant="outlined" disabled={data == null} color={data?.p_summary?.name ? "primary" : "secondary"} onClick={() => setSearchDialogMode(3)} sx={{width: "calc(50% - 4px)", fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}} startIcon={data?.p_summary?.name ? null : <AddIcon style={{fontSize: "12px"}} />} >
              {data?.p_summary?.name ? t("h2h.changePlayer", {name: shortenUsername(data?.p_summary?.name, 5)}) : t("h2h.partner")}
            </Button>
            <Button variant="outlined" disabled={data == null} color={data?.op_summary?.name ? "primary" : "secondary"} onClick={() => setSearchDialogMode(4)} sx={{width: "calc(50% - 4px)", fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}} startIcon={data?.op_summary?.name ? null : <AddIcon style={{fontSize: "12px"}} />} >
              {data?.op_summary?.name ? t("h2h.changePlayer", {name: shortenUsername(data?.op_summary?.name, 5)}) : t("h2h.opponent")}
            </Button>
        </Stack>
}

export function H2HFullSummary({data}) {
  const { t } = useTranslation();
  const firstSummary = data?.my_summary;
  const secondSummary = data?.o_summary;
  const thirdSummary = data?.p_summary ? data.p_summary : data?.my_summary;
  const fourthSummary = data?.op_summary ? data.op_summary : data?.o_summary;

  const theme = useTheme();

  return <><H2HSummary my_summary={firstSummary} o_summary={secondSummary} />

        {thirdSummary ? <H2HSummary my_summary={thirdSummary} o_summary={fourthSummary} /> : null}
        
        <OutlinedBox sx={{m: 1, mt: 0}}>
        <Typography variant="caption" fontWeight="bold" color="text.primary_bold" component="div" sx={{px: 1, py: 0.5}}>
          {t("h2h.recentMatches")}
        </Typography>
        <Divider sx={{width: "100%"}}/>

        <H2HRecentResults summary={data?.my_summary} />
        {data?.p_summary ? <>
          <Divider sx={{width: "100%"}}/>
          <H2HRecentResults summary={data?.p_summary} />
        </> : null}
        <Divider sx={{width: "100%"}}/>
        <H2HRecentResults summary={data?.o_summary} />
        {data?.op_summary ? <>
          <Divider sx={{width: "100%"}}/>
          <H2HRecentResults summary={data?.op_summary} />
        </> : null}
        </OutlinedBox>

        {data?.encounters?.length > 0 && <OutlinedBox sx={{m: 1, mt: 0}}>
        <Typography variant="caption" fontWeight="bold" color="text.primary_bold" component="div" sx={{px: 1, py: 0.5}}>
          {t("h2h.previousEncounters")}
        </Typography>
        <Divider sx={{width: "100%"}}/>

        {data?.encounters.map((encounter, index) => (
          <>
          {index > 0 && <Divider sx={{width: "100%"}}/>}
          <Box key={encounter.player11 + "-" + encounter.player12 + "-" + encounter.player21 + "-" + encounter.player22 + "-" + encounter.score + "-" + index} sx={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", p: 1}}>
            <Typography variant="caption" color="text.primary_bold" sx={{flexGrow: 1}}>
              <b style={{opacity: encounter.winner == 1 ? 1 : 0.4}}>{getFirstInitialAndLastName(encounter.player11_name)}&nbsp;/&nbsp;{getFirstInitialAndLastName(encounter.player12_name)}</b><br/><b style={{opacity: encounter.winner == 2 ? 1 : 0.4}}>{getFirstInitialAndLastName(encounter.player21_name)}&nbsp;/&nbsp;{getFirstInitialAndLastName(encounter.player22_name)}</b>
            </Typography>
            <Typography variant="caption" color="text.primary_bold" sx={{flexGrow: 1, fontWeight: "bold", textAlign: "right"}}>
              {encounter.score} <br/> <b style={{fontWeight: "normal", color: theme.palette.text.secondary}}>{encounter.date ? formatDateDifference(encounter.date) : ""}</b>
            </Typography>
          </Box>
          </>
        ))}
        </OutlinedBox>}
        </>
}

export function H2HInfo() {
  const { t } = useTranslation();
  return <OutlinedBox sx={{m: 1, mt: 0}}>
        <Typography variant="caption" fontWeight="bold" color="text.primary_bold" component="div" sx={{px: 1, py: 0.5}}>
          {t("h2h.infoTitle")}
        </Typography>
        <Divider sx={{width: "100%"}}/>
        <Typography variant="caption" color="text.secondary" component="div" sx={{mx: 1, py: 0.5}}>
          {t("h2h.infoBody")}
        </Typography>
        </OutlinedBox>
}


export function H2HDialog({open, onClose, dialogData}) {
  const { t } = useTranslation();
    const theme = useTheme();

  const [searchDialogMode, setSearchDialogMode] = React.useState(0); // 0 = none, 1 = search 11, 1 = search 12, 2 = search 21, 3 = search 22
  
  const [myId, setMyId] = React.useState(null);
  const [opponentId, setOpponentId] = React.useState(null);
  const [partnerId, setPartnerId] = React.useState(null);
  const [opponentPartnerId, setOpponentPartnerId] = React.useState(null);

  React.useEffect(() => {
    if (dialogData) {
      setMyId(dialogData.player1);
      setOpponentId(dialogData.player2);
      setPartnerId(dialogData.player3);
      setOpponentPartnerId(dialogData.player4);
    }
  }, [dialogData]);

  const data = useHead2Head(myId, opponentId, partnerId, opponentPartnerId);

//const [value, setValue] = React.useState(0);

  

    return data && <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" sx={{
      "& .MuiDialog-container": {
        "& .MuiPaper-root": {
          width: "calc(100% - 16px)",
          margin: 0,
          borderRadius: 2,
          p: 1,
        },
      },
    }}>
          {/*<ActivityTab labels={["Enkel", "Dubbel"]} value={value} setValue={setValue} sx={{borderRadius: 0, mt: 0}} />*/}

        <H2HHeader data={data} myId={null} partnerId={partnerId} opponentId={opponentId} opponentPartnerId={opponentPartnerId} />

        <Divider sx={{my: 2}}/>

        <H2HSelect data={data} setSearchDialogMode={setSearchDialogMode} />

        <Divider sx={{my: 2}}/>

        <H2HFullSummary data={data} />
        
        <H2HInfo />

        <SearchPlayerDialog mode={searchDialogMode} onClickPlayer={(player) => {
          if (searchDialogMode === 1 && player) {
            setMyId(player.id);
          } else if (searchDialogMode === 2 && player) {
            setOpponentId(player.id);
          } else if (searchDialogMode === 3 && player) {
            setPartnerId(player.id);
          } else if (searchDialogMode === 4 && player) {
            setOpponentPartnerId(player.id);
          }
          setSearchDialogMode(0);
        }} />

    </Dialog>
}

export function SearchPlayerDialog({mode, onClickPlayer}) {
  const { t } = useTranslation();
  const [search, setSearch] = React.useState("");

  const players = useSearch(search, true);

  React.useEffect(() => {
    if (mode === 0) {
      setSearch("");
    }
  }, [mode]);

  const theme = useTheme();

  return <Dialog open={mode !== 0} onClose={() => onClickPlayer(null)} fullWidth maxWidth="xs">     

        <Box sx={{p: 2, overflow: "scroll"}}>      
            <InputBase 
                autoFocus
                fullWidth
                placeholder={t("activityCard.searchPlayer")}
                startAdornment={<SearchIcon style={{color: "#999", marginRight: 8}} />} 
                inputProps={{sx: {textTransform: search.length > 0 ? "capitalize" : "none"}}}
                sx={{borderRadius: 1, backgroundColor: "white", border: "1px solid", borderColor: "divider", py: 0.5, px: 1}}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            
            <Box sx={{mt: 1, height: 300}}>
              {search.length  < 5 ?
            <OutlinedBox sx={{py: 1, px: 1, fontStyle: "italic", textAlign: "center", mt: 1}}>
              <Typography variant="body2" color="text.secondary">
                {t("h2h.refineSearch")}
              </Typography>
            </OutlinedBox>
            : players.slice(0,50).map((player) => (
                <Box key={player.id} sx={{display: "flex", alignItems: "center", justifyContent: "space-between", py: 1, px: 0.5, cursor: "pointer", "&:hover": {backgroundColor: "action.hover"}, borderRadius: 1}} onClick={() => {
                    onClickPlayer(player);
                }}>
                    <PlayerName name={player.name} name_club={player.name_club} rank={player.padel} color={theme.palette.primary.main} shortenUsernameLength={100} />
                    <ChevronRightIcon sx={{color: "#999"}} />
                </Box>
            ))}
            </Box>

            </Box> 
            
            <DialogActions>
            <Button onClick={() => onClickPlayer(null)}>{t("common.close")}</Button>
            </DialogActions>
        </Dialog>
        
}